import styled from 'styled-components';

export const Wrapper = styled.div`
  && {
    background-color: white;
    .section {
      padding: 25px 40px;
    }
    .header-choose {
      height: 75px;
      background-color: rgba(236, 255, 184, 1);
      padding-left: 60px;
      display: flex;
      align-items: center;
    }
    .table {
      margin-top: 40px;
    }
    .status-clinic {
      max-width: 200px;
      border: 1px solid black;
      padding: 8px 12px;
      text-align: center;
      background-color: #ffffff;
    }
  }
`;
